import {
  axiosClient,
  checkIfUserAdmin,
  checkIfUserDeveloper,
  checkIfUserPublisher,
  getUserAccessByPortal,
} from '@/services/utilities';
import { userStore } from '@/store/users';
import { useQuery } from 'react-query';

export const useUserByUsername = (username: string, userId?: number) => {
  const queryKey = ['user', username];
  const [userSearched, setUserSearched] = userStore((state) => [
    state.userSearched,
    state.setUserSearched,
  ]);

  const fetchUserByUsername = async (username: string) => {
    const { data } = await axiosClient.get(`/users/${username}`);
    return data;
  };

  const { isLoading, isError, refetch, error } = useQuery({
    queryKey,
    queryFn: async () => {
      const user = await fetchUserByUsername(username);

      const isUserAdmin = await checkIfUserAdmin(username);
      const isUserPublisher = await checkIfUserPublisher(username);
      const isUserDeveloper = await checkIfUserDeveloper(username);
      let userActivedPortal:
        | 'admin-portal'
        | 'publisher-portal'
        | 'developer-portal' = isUserAdmin
        ? 'admin-portal'
        : isUserPublisher
        ? 'publisher-portal'
        : 'developer-portal';

      const userRole = await getUserAccessByPortal(userActivedPortal, username);
      const userRolePublisher = await getUserAccessByPortal(
        'publisher-portal',
        username,
      );
      const userRoleAdmin = await getUserAccessByPortal(
        'admin-portal',
        username,
      );
      const userRoleDeveloper = await getUserAccessByPortal(
        'developer-portal',
        username,
      );

      return {
        ...user,
        isAdmin: isUserAdmin,
        isPublisher: isUserPublisher,
        isDeveloper: isUserDeveloper,
        isDeveloperActive:
          userRoleDeveloper.length >= 1 ? userRoleDeveloper[0].active : false,
        isPublisherActive:
          userRolePublisher.length >= 1 ? userRolePublisher[0].active : false,
        isAdminActive:
          userRoleAdmin.length >= 1 ? userRoleAdmin[0].active : false,
        isAllowed: userRole.length >= 1 ? userRole[0].allow : false,
        isActive: userRole.length >= 1 ? userRole[0].active : false,
      };
    },

    onSuccess: (user) => {
      setUserSearched([
        {
          userId: userId ? userId : null,
          ...user,
        },
      ]);
    },
  });

  return { user: userSearched, isLoading, isError, error, refetch };
};
